'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getReportingYearStart = undefined;
var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');
var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');
var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
var _constants = require('../constants');
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var getReportingYearStart = exports.getReportingYearStart = function getReportingYearStart(sdmxJson) {
  var attributes = R.pipe(R.pathOr({}, ['data', 'structure', 'attributes']), function (_ref) {
    var _ref$dataSet = _ref.dataSet,
      dataSet = _ref$dataSet === undefined ? [] : _ref$dataSet,
      _ref$observation = _ref.observation,
      observation = _ref$observation === undefined ? [] : _ref$observation,
      _ref$series = _ref.series,
      series = _ref$series === undefined ? [] : _ref$series;
    return [].concat((0, _toConsumableArray3.default)(dataSet), (0, _toConsumableArray3.default)(observation), (0, _toConsumableArray3.default)(series));
  })(sdmxJson);
  var reportYearStartAttr = R.find(function (_ref2) {
    var id = _ref2.id;
    return id === _constants.REPORTING_YEAR_START_DAY || id === _constants.REPYEARSTART;
  }, attributes) || {};
  var reportYearStart = R.pathOr('--01-01', ['values', 0, 'value'], reportYearStartAttr);
  var _R$match = R.match(/[\d]{2}/g, reportYearStart),
    _R$match2 = (0, _slicedToArray3.default)(_R$match, 2),
    _R$match2$ = _R$match2[0],
    month = _R$match2$ === undefined ? '01' : _R$match2$,
    _R$match2$2 = _R$match2[1],
    day = _R$match2$2 === undefined ? '01' : _R$match2$2;
  return {
    month: month,
    day: day
  };
};